import { ErrorMessage, Form, Formik } from 'formik'
import usePost from '@/Utils/Hooks/usePost'
import { AdminFAQsAPI } from '@/Utils/APIRequest/Endpoints'
import { CustomToast } from '@/Utils/CustomToast'
import Modal from '@/Component/Common/Modal'
import { RequiredField, YupObject } from '@/Utils/ValidationSchema'
import FormikInput from '@/Component/Common/Forms/FormikInput'
import ErrorMessages from '@/Utils/ErrorMessages'
import FormikTextarea from '@/Component/Common/Forms/FormikTextarea'
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG'
import GradientButton from '@/Component/Common/Forms/GradientButton'
import BorderButton from '@/Component/Common/Forms/BorderButton'
import FormikSelect from '@/Component/Common/Forms/FormikSelect'
import ValidationMsg from '@/Utils/ValidationSchema/ValidationMsg'

const FaqModal = (props) => {
    const { modal, setModal, refetch, activeTab } = props

    const { isPending, mutate } = usePost(modal?.id ? `${AdminFAQsAPI}/${modal?.id}` : AdminFAQsAPI, null, (response) => {
        if (response.status == 201 || response.status == 200) {
            CustomToast("success", modal?.id ? 'FAQ updated successfully' : 'FAQ added successfully')
            refetch()
            setModal(null)
        }
    }, modal?.id ? 'put' : null);

    return (
        <Modal modalSize="md:w-2/4 xl:w-1/3 2xl:w-1/4" modal={modal} setModal={setModal} headerTitle={`${modal?.questions ? 'Edit' : 'Add'} FAQ`}>
            <Formik
                enableReinitialize initialValues={{ questions: modal?.questions ?? "", answers: modal?.answers ?? "", faq_for: activeTab }} validationSchema={YupObject({ questions: RequiredField("Faq question is required"), answers: RequiredField("Faq answer is required")})}
                onSubmit={(values: any) => {
                    mutate(values)
                }}
            >
                {({ errors, touched }) => (
                    <Form>
                        <div className='mb-4 relative'>
                            <FormikInput inputProps={{ type: "text", name: "questions", placeholder: "Enter faq question", maxLength: '200' }} />
                            <ErrorMessages fieldName="questions" errors={errors} touched={touched} />
                        </div>
                        <div className='mb-4 relative'>
                            <FormikTextarea textareaProps={{ type: "text", name: "answers", placeholder: "Enter faq answer", rows: 4 }} />
                            <ErrorMessages fieldName="answers" errors={errors} touched={touched} />
                        </div>
                        <div className="flex items-center justify-center gap-3.5 mt-5">
                            <GradientButton buttonType="submit" customClass="flex items-center gap-2" disable={isPending}>
                                Submit
                                {isPending && <LoaderSVG />}
                            </GradientButton>
                            <BorderButton buttonType="button" title="Cancel" onClick={() => setModal(null)} />
                        </div>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}

export default FaqModal
